package dev.mobilearchitecture.web

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLScriptElement

var isVantaInitialized = false

fun initVanta() {
    if (isVantaInitialized) return
    isVantaInitialized = true

    val head = document.head ?: return

    val threeJsScript = document.createElement("script") as HTMLScriptElement
    threeJsScript.src = "https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js"

    val vantaScript = document.createElement("script") as HTMLScriptElement
    vantaScript.src = "https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.net.min.js"

    threeJsScript.onload = {
        head.appendChild(vantaScript)
        Unit
    }

    vantaScript.onload = {
        // Initialize Vanta.NET effect dynamically after scripts load
        js("""
            if (window.VANTA && window.VANTA.NET) {
                window.VANTA.NET({
                    el: "#hero-vanta-bg",
                    mouseControls: true,
                      touchControls: true,
                      gyroControls: false,
                      minHeight: 200.00,
                      minWidth: 200.00,
                      scale: 1.00,
                      scaleMobile: 1.00,
                      backgroundColor: 0x0
                })
            }
        """)
        Unit
    }

    head.appendChild(threeJsScript)
}
